import PropTypes from "prop-types";

// Layouts
import PayPlansFacade from "@PayPlans/Layouts/PayPlansFacade";

// Model
import PayPlansModel from "@PayPlans/models/Managers/Sales";

function Sales({ position = "Sales Manager", positionType = "Departmental" }) {
	return (
		<PayPlansFacade
			position={position}
			positionType={positionType}
			defaultSections={["default", "crossStoreCommissions"]}
			cacheManagement={{
				clearAbsoluteIndexes: [
					"locationFS",
					"programDetails",
					"models",
					"modelYears",
					"payPlanCsiMetrics",
					"backendProductsCount",
					"payPlansSidebarTree",
					"activeFrequencies",
					"payPlanSalesPerformanceReportVersions",
					"salesPerformanceProducts",
				],
			}}
		>
			<PayPlansModel />
		</PayPlansFacade>
	);
}
Sales.propTypes = {
	position: PropTypes.string,
	positionType: PropTypes.string,
};

export default Sales;
